import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "../data/siteContent";
import { ChapterHeading, ScrollReveal, EASE } from "./shared";

const Industries = () => (
    <section id="industries" data-testid="industries-section" className="py-24 md:py-36 px-6 md:px-12">
        <ChapterHeading index="03" title="Industries We Serve" />

        <div className="mt-12 md:mt-16">
            <ScrollReveal>
                <h2 className="font-heading uppercase font-semibold text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-tight max-w-3xl">
                    Behind the machines
                    <br />
                    <span className="text-outline-copper">that build India.</span>
                </h2>
            </ScrollReveal>
        </div>

        <div className="mt-14">
            {INDUSTRIES.map((ind, i) => (
                <motion.div
                    key={ind.name}
                    data-testid={`industry-row-${i}`}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }}
                    transition={{ duration: 0.8, delay: i * 0.08, ease: EASE }}
                    className="group grid grid-cols-12 gap-4 md:gap-8 items-center py-7 md:py-9 border-b border-[#E5E5E5] first:border-t"
                >
                    <span className="col-span-2 md:col-span-1 font-heading text-copper/80 text-sm md:text-base tracking-[0.2em]">
                        {String(i + 1).padStart(2, "0")}
                    </span>

                    <div className="col-span-10 md:col-span-6">
                        <h3 className="font-heading uppercase font-medium text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight group-hover:text-copper transition-colors duration-300">
                            {ind.name}
                        </h3>
                        <p className="mt-2 text-sm md:text-base text-[#737373] max-w-lg leading-relaxed">
                            {ind.note}
                        </p>
                    </div>

                    <div className="hidden md:block md:col-span-4 relative overflow-hidden border border-[#D9D9D9] aspect-[16/7]">
                        <img
                            src={ind.image}
                            alt={ind.name}
                            loading="lazy"
                            className="w-full h-full object-cover grayscale-[45%] transition-[transform,filter] duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
                        />
                        <div className="absolute inset-0 bg-[#FAFAFA]/25 group-hover:bg-transparent transition-colors duration-500" />
                    </div>

                    <div className="hidden md:flex md:col-span-1 justify-end">
                        <ArrowUpRight
                            size={28}
                            className="text-[#525252] transition-all duration-300 group-hover:text-copper group-hover:translate-x-1 group-hover:-translate-y-1"
                        />
                    </div>
                </motion.div>
            ))}
        </div>

        <ScrollReveal delay={0.1} className="mt-12">
            <p className="text-sm md:text-base text-[#737373] max-w-xl leading-relaxed">
                …and any builder of heavy machinery who needs a part that fits right the first
                time. If it rotates, slides or drives — we can machine it.
            </p>
        </ScrollReveal>
    </section>
);

export default Industries;
